import { useNavigate, useLocation, NavigateOptions } from 'react-router';

export const useNavigatePreservingQueryParams = () => {
  const routerNavigate = useNavigate();
  const { search } = useLocation();

  const queryNavigation = (to: string | number, options?: NavigateOptions) => {
    if (typeof to === 'number') {
      // Se to for -1, volta uma página na pilha de histórico
      routerNavigate(-1);
    } else {
      // Verifica se 'to' já contém uma string de consulta
      const separator = to.includes('?') ? '&' : '';
      routerNavigate(`${to}${separator}${search}`, options);
    }
  };

  return { queryNavigation };
};
